export const MFA_BLOCK_COPY = {
    title: "Two-factor authentication now required",
    subtitle:
        "Your role now requires that you use two-factor authentication (2FA) to sign in. 2FA adds a second layer of security in case your password is ever lost or stolen.",
    steps: [
        "You’ll be signed out of Buildertrend",
        "Set up a second verification method",
        "Sign in with new verification method from now on",
    ],
    primaryCta: "Continue to setup",
    secondaryCta: "Learn more about MFA",
} as const;
